import type React from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {COLORS} from "~/style/colors-ts";

type NotificationAlertActionsProps = {
    actionText?: React.ReactNode;
    onAction?: () => void;
    onClose: () => void;
};

/** Retry (when provided) plus a close control — MUI Alert hides `onClose` if `action` is set. */
export const NotificationAlertActions: React.FC<NotificationAlertActionsProps> = ({
                                                                                      actionText,
                                                                                      onAction,
                                                                                      onClose,
                                                                                  }) => (
    <>
        {onAction
            ? <Button sx={{color:COLORS.white[900]}} size="small" onClick={onAction}>
                {actionText ?? 'Retry'}
            </Button>
            : null}
        <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
            <CloseIcon fontSize="small"/>
        </IconButton>
    </>
);
